import React, {useEffect, useMemo, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import { setActiveJob } from "../../../Store/Slice/jobsSlice";
import { setRescheduleConfirmModal } from "../../../Store/Slice/scheduleSlice";
import { clearState } from "../../../Store/Slice/scheduleSlice";
import useCreateJob from "../../../Global/Api/Schedule/createJobApi";
import Button from "../../../UI/Button";
import moment from "moment/moment";

export default function ScheduleFinish() {
  const {title: jobTitle} = useParams();
  const { reschedule } = useCreateJob();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const job = useCreateJob();
  const { activeJob } = useSelector((state) => state.rootReducer.jobsSlice);
  const scheduleStep = useSelector((state) => state.rootReducer.scheduleSlice.schedule_step);


    const scheduledDate = new Date(activeJob?.job_datetime).getTime();
    const currentDate = new Date(new Date().toLocaleString("en-US", { timeZone: activeJob?.job_timezone })).getTime();

    const diffInMs = scheduledDate - currentDate;

    const isDateIn24Hrs = useMemo(() => {
       return diffInMs > 0 && diffInMs <= 24 * 60 * 60 * 1000;
    }, [activeJob?.job_datetime]);

    const isJobPast = useMemo(() => {
        return diffInMs < 0;
    }, [diffInMs]);

    const handleCancelJob = async () => {
      navigate('/');
      await dispatch(setActiveJob({}));
      await dispatch(clearState());
    };
    const isButtonDisabled = (jobTitle && (!isDateIn24Hrs && !isJobPast)) ? scheduleStep < 4 : scheduleStep < 5;

    const rescheduleTheJob = () => {
        reschedule(jobTitle);
        dispatch(clearState());
    };


  const handleSubmitButton = async () => {
      if(jobTitle && (isJobPast || isDateIn24Hrs)){
        dispatch(setRescheduleConfirmModal(true));
      } else if(jobTitle && !isDateIn24Hrs){
        rescheduleTheJob();
      }
      else {
          await job.create();
          dispatch(clearState());
      }
  }
  return (
    <div className="schedule__finish">
      <div className="schedule__finish-cancel">
        <Button text="Cancel" type="light" onClick={handleCancelJob}/>
      </div>
      <div className="schedule__finish-place">
        <Button
          text={jobTitle ? "Reschedule the job" : "Place the job"}
          onClick={handleSubmitButton}
          disabled={isButtonDisabled}
        />
      </div>
    </div>
  );
}
